/* global Config */
// Vendor Libs
import { request } from 'axios';
import isPlainObject from 'lodash.isplainobject';
import join from 'lodash.join';
import uuid from 'uuid'; // Utils

import { cleanObject } from './object';

var getError = function getError(type, error) {
  return "There was a problem with the " + type + ": " + error;
};

var triggerAuthentication = function triggerAuthentication() {
  window.location.href = "" + Config.oauth.oauthBaseUrl + Config.oauth.authorizationUrl + "?" + new URLSearchParams({
    client_id: Config.oauth.clientId,
    redirect_uri: Config.oauth.redirectUrl,
    response_type: 'code',
    scope: ['user_info'],
    state: uuid.v4()
  }).toString();
};

export var serviceCaller = function serviceCaller(serviceParams, ajaxParams) {
  var _serviceParams$handle = serviceParams.handleError,
      handleError = _serviceParams$handle === void 0 ? function (error, status, data) {
    return {
      error: error,
      status: status,
      data: data
    };
  } : _serviceParams$handle,
      _serviceParams$handle2 = serviceParams.handleFetched,
      handleFetched = _serviceParams$handle2 === void 0 ? function (data) {
    return {
      data: data
    };
  } : _serviceParams$handle2;

  if (ajaxParams.timeout === undefined) {
    ajaxParams.timeout = 30000;
  }

  return request(ajaxParams).then(function (response) {
    var data = cleanObject(response.data) || {};
    var error = data.error;

    if (error) {
      throw handleError(getError('response', isPlainObject(error) ? JSON.stringify(error) : error), response.status);
    }

    return handleFetched(data, response);
  })["catch"](function (error) {
    var message = error.message,
        response = error.response;
    var errorText;
    var unauthorized = false;
    var requestUrl = '';
    var responseStatus;
    var responseData;

    if (response) {
      var config = response.config,
          data = response.data,
          status = response.status,
          statusText = response.statusText;
      unauthorized = status === 401;
      requestUrl = config && config.url ? config.url : '';

      if (data && data.error) {
        errorText = data.error;
      } else if (status === 401) {
        errorText = 'Unauthorized';
      } else if (status === 403) {
        errorText = 'Forbidden';
      } else if (data && Array.isArray(data) && data.length > 0) {
        errorText = join(data, '. ');
      } else if (statusText && statusText !== 'error') {
        errorText = statusText;
      } else if (message && message !== 'error') {
        errorText = message;
      }

      errorText += ".  Status code: " + status + ".";
      responseStatus = status || {};
      responseData = data || {};
    } else if (message && message !== 'error') {
      errorText = message;
    } else {
      errorText = 'An unknown error has occurred';
    }

    if (unauthorized && requestUrl !== 'resetPassword') {
      triggerAuthentication();
    }

    throw handleError(getError('request', errorText), responseStatus, responseData);
  });
};